import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { identityApi } from "@/api/identityApi";
import { resolveSafeReturnUrl } from "@/lib/returnUrl";

export function LogoutPage() {
    const [params] = useSearchParams();

    useEffect(() => {
        let cancelled = false;
        void (async () => {
            try {
                await identityApi.logout();
            } finally {
                if (!cancelled) {
                    const target = resolveSafeReturnUrl(params.get("returnUrl"));
                    if (target !== "/") {
                        window.location.assign(target);
                    }
                }
            }
        })();
        return () => { cancelled = true; };
    }, [params]);

    return (
        <Card className="w-full">
            <CardHeader>
                <CardTitle>You're signed out</CardTitle>
                <CardDescription>
                    Your Athavita session has ended on this device.
                </CardDescription>
            </CardHeader>
            <CardContent className="text-sm">
                <Link to="/login" className="font-semibold text-primary hover:underline">
                    Sign in again
                </Link>
            </CardContent>
        </Card>
    );
}
